import React, { ReactNode, useRef } from 'react';
import styled from 'styled-components';

let toolbarSequence = 0;

const Toolbar = styled.div`
  &.ql-toolbar.ql-snow {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2px;
  }

  &.ql-toolbar.ql-snow .ql-formats {
    margin-right: 4px;
  }

  .follow-up-quill-ai-actions {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-left: auto;
  }

  &.ql-toolbar.ql-snow .follow-up-quill-ai-actions {
    flex: 0 0 auto;
  }

  &.ql-toolbar.ql-snow .follow-up-quill-ai-actions button.ui.button {
    width: auto;
    height: auto;
    margin: 0;
    padding: 7px 14px;
    background: #eadfff !important;
    color: #5e2ca5 !important;
    display: inline-flex;
    align-items: center;
    overflow: visible;
    line-height: 1.2;
    white-space: nowrap;
  }

  @media (max-width: 720px) {
    .follow-up-quill-ai-actions {
      width: 100%;
      margin-left: 0;
      justify-content: flex-end;
    }
  }
`;

export const useFollowUpQuillToolbarId = (): string => {
  const idRef = useRef<string>();

  if (!idRef.current) {
    toolbarSequence += 1;
    idRef.current = `follow-up-quill-toolbar-${toolbarSequence}`;
  }

  return idRef.current;
};

type FollowUpQuillToolbarProps = {
  id: string;
  children?: ReactNode;
};

const FollowUpQuillToolbar = ({
  id,
  children,
}: FollowUpQuillToolbarProps) => (
  <Toolbar id={id} className="ql-toolbar ql-snow">
    <span className="ql-formats">
      <select className="ql-align" defaultValue="" />
    </span>
    <span className="ql-formats">
      <button type="button" className="ql-bold" />
      <button type="button" className="ql-italic" />
      <button type="button" className="ql-underline" />
      <button type="button" className="ql-strike" />
    </span>
    <span className="ql-formats">
      <button type="button" className="ql-list" value="ordered" />
      <button type="button" className="ql-list" value="bullet" />
    </span>
    <span className="ql-formats">
      <button type="button" className="ql-indent" value="-1" />
      <button type="button" className="ql-indent" value="+1" />
    </span>
    <span className="ql-formats">
      <select className="ql-size" defaultValue="normal">
        <option value="normal">Normal</option>
        <option value="large">Large</option>
        <option value="huge">Huge</option>
      </select>
    </span>
    <span className="ql-formats">
      <select className="ql-color" />
      <select className="ql-background" />
    </span>
    <span className="follow-up-quill-ai-actions">{children}</span>
  </Toolbar>
);

export default FollowUpQuillToolbar;
